<template>
  <div class="toggle-animated">
    <input @change="$emit('check-toggle', { value: check })" v-model="check" type="checkbox" id="toggle">
    <label for="toggle">
    </label>
  </div>
</template>

<script>
export default {
  name: 'ToggleAnimated',
  props: {
    checkChange: {
      type: Boolean
    }
  },
  data () {
    return {
      check: false
    }
  },
  watch: {
    checkChange (value) {
      this.check = value
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-animated {
  position: relative;
  width: 45px;
  height: 35px;
  label {
    transform: scale(.23);
    left: -150%;
    top: 17%;
    width: 12em;
    height: 1.5em;
    background-color: white;
    position: absolute;
    cursor: pointer;
    --animation-curve: cubic-bezier(1, 0, 0, 1);

    &::before,
    &::after {
      content: "";
      width: 12em;
      height: 1.5em;
      background-color: white;
      position: absolute;
      display: block;
      color: red;
      transition: all 0.6s var(--animation-curve);
    }

    &::before {
      top: -250%;
      left: 0%;
      transform: rotateZ(0deg);
      transform-origin: left top;
    }

    &::after {
      bottom: -250%;
      left: 0%;
      transform: rotateZ(0deg);
      transform-origin: left bottom;
    }
  }

  #toggle:checked ~ label::before {
    content: "";
    background-color: white;
    transform: rotateZ(41deg);
    left: 10%;
  }

  #toggle:checked ~ label::after {
    content: "";
    background-color: white;
    transform: rotateZ(-41deg);
    left: 10%;
  }

  #toggle:checked ~ label {
    background-color: transparent;
  }

  #toggle ~ label {
    transition: all 0.5s var(--animation-curve);
  }

  input {
    display: none;
  }
}
</style>